import React from "react";
import { Colors } from "../../Constants/colors";
import schoolLogo from "../../images/school-color-logo.png";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import {
  FONT_SIZE,
  FONT_WEIGHT,
  ALIGN_ITEMS,
  FLEX_DIRECTION,
  JUSTIFY_CONTENT,
} from "../../Constants/Enums/styles.enum";

const SideMenuHeader: React.FC = () => {
  return (
    <header
      style={{
        backgroundColor: Colors.TangerineOrange,
        display: "flex",
        flexDirection: FLEX_DIRECTION.ROW,
        alignItems: ALIGN_ITEMS.CENTER,
        justifyContent: JUSTIFY_CONTENT.CENTER,
        padding: "1.25rem 1rem",
        height: "72px",
        width: "100%",
        gap: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        position: "relative",
        zIndex: 1,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: ALIGN_ITEMS.CENTER,
          justifyContent: JUSTIFY_CONTENT.CENTER,
          flexShrink: 0,
        }}
      >
        <div className="school-logo">
          <img
            src={schoolLogo}
            alt="Rose Mount Pre School Logo"
            className="logo"
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: FLEX_DIRECTION.COLUMN,
          paddingLeft: "4px",
          flex: 1,
          lineHeight: 1.3,
          gap: "2px",
        }}
      >
        <span
          style={{
            fontFamily: FontFamily.POPPINS_BOLD,
            fontSize: FONT_SIZE.F20,
            fontWeight: FONT_WEIGHT.BOLD,
            color: Colors.White,
            letterSpacing: "0.4px",
          }}
        >
          Rose Mount
        </span>
        <span
          style={{
            fontFamily: FontFamily.POPPINS_BOLD,
            fontSize: FONT_SIZE.F14,
            fontWeight: FONT_WEIGHT.MEDIUM,
            color: Colors.White,
            opacity: 0.95,
            letterSpacing: "0.2px",
          }}
        >
          Pre School
        </span>
      </div>
    </header>
  );
};

export default SideMenuHeader;
